var _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconErrorRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 16.5C32.5 25.3365 25.3365 32.5 16.5 32.5C7.66343 32.5 0.5 25.3365 0.5 16.5C0.5 7.66343 7.66343 0.5 16.5 0.5C25.3365 0.5 32.5 7.66343 32.5 16.5Z",
    fill: "#FAC9C5",
    stroke: "#A52921"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.574,
    y: 22.6932,
    width: 17.2868,
    height: 2.15664,
    rx: 1,
    transform: "rotate(-50 10.574 22.6932)",
    fill: "#A52921"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7628,
    y: 9.2681,
    width: 17.2868,
    height: 2.15664,
    rx: 1,
    transform: "rotate(50 11.7628 9.2681)",
    fill: "#A52921"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorRed);
export default __webpack_public_path__ + "static/media/Icon_Error_Red.122e39e37e5dcea062701bc05f1dc584.svg";
export { ForwardRef as ReactComponent };